<template>
  <div class="settings">
    <VPBreadcrumbs :elements="[{ text: 'Whitelabel', to: parentRoute }, { text: 'New Whitelabel' }]" />
    <Form
      :form-id="formId"
      :initial-values="Whitelabel.getNew()"
    >
      <WhitelabelFields />
      <FormActionButtons
        :show-cancel="isFormDirty()"
        :show-save="isFormDirty()"
        @save="handleSave"
        @cancel="onCancel"
      />
    </Form>
  </div>
</template>

<script setup lang="ts">
import { Form, useFormsStoreComposable } from 'vuniform';
import { useWhitelabelStore } from '@/stores/whitelabel';
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';
import VPBreadcrumbs from '@/components/VPBreadcrumbs.vue';
import FormActionButtons from '@/components/form/FormActionButtons.vue';
import * as Whitelabel from '@/types/Whitelabel';
import type { SaveWhitelabelConfigMutationInput, WhitelabelAttributes } from '@/generated/graphql';
import WhitelabelFields from './WhitelabelFields.vue';

const whitelabelStore = useWhitelabelStore();
const toast = useToast();
const router = useRouter();
const parentRoute = { name: 'WhitelabelIndex' };

const { formId, formsStore, formGetValues, isFormDirty } = useFormsStoreComposable('new-whitelabel-form');

const handleSave = async () => {
  const values = formGetValues<WhitelabelAttributes>();
  delete (values as { attachment: any })['attachment'];
  const payload: SaveWhitelabelConfigMutationInput = {
    clientMutationId: formId,
    config: values,
  };
  const { result: newWhitelabel, errors } = await whitelabelStore.saveWhitelabel(payload);
  if (errors) {
    formsStore.SET_ERRORS({ requesterId: formId, errors });
    return;
  }
  if (!newWhitelabel) {
    return;
  }
  toast.success(`Whitelabel '${newWhitelabel.name}' added successfully!`);
  router.push(parentRoute);
};
const onCancel = () => formsStore.RESET_FIELD_VALUES(formId);
</script>
